//
//
//
//
//
//


export default {
  name: 'Tab',
}



// WEBPACK FOOTER //
// ./client/components/Common/Tab/Tab.vue